<div
  class="ask-frequency-field"
  [class.ask-frequency-field--halves]="layout() === 'halves'"
  [formGroup]="group()">
  <mat-form-field class="ask-frequency-field__kind" subscriptSizing="dynamic">
    <mat-label>{{ labelKey() | translate }}</mat-label>
    <mat-select formControlName="kind" required data-testid="select-ask-frequency">
      @for (kind of kinds; track kind) {
        <mat-option [value]="kind">{{ kindLabelKeys[kind] | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (isRepeating() || isCountingVisible()) {
    <div class="ask-frequency-field__details">
      @if (isRepeating()) {
        <mat-form-field class="ask-frequency-field__count" subscriptSizing="dynamic">
          <mat-label>{{ 'SHARED.SYSTEM.VALUE' | translate }}</mat-label>
          <input
            matInput
            type="number"
            min="1"
            [max]="maxCount()"
            formControlName="count"
            autocomplete="off"
            required
            data-testid="input-ask-frequency-count" />
          @if (group().controls.count.hasError('askFrequencyCount')) {
            <mat-error>{{
              'SHARED.ASK_FREQUENCY.COUNT_RANGE' | translate: { max: maxCount() }
            }}</mat-error>
          }
        </mat-form-field>
      }

      @if (isCountingVisible()) {
        <div class="ask-frequency-field__counting">
          <mat-button-toggle-group
            formControlName="countingScope"
            hideSingleSelectionIndicator
            data-testid="toggle-ask-frequency-counting"
            [attr.aria-label]="'SHARED.ASK_FREQUENCY.COUNTING' | translate">
            <mat-button-toggle
              [value]="countingScopes.Venue"
              data-testid="toggle-counting-per-unit"
              >{{ 'SHARED.ASK_FREQUENCY.PER_UNIT' | translate: unitParams() }}</mat-button-toggle
            >
            <mat-button-toggle
              [value]="countingScopes.Account"
              data-testid="toggle-counting-per-account"
              >{{ 'SHARED.ASK_FREQUENCY.PER_ACCOUNT' | translate }}</mat-button-toggle
            >
          </mat-button-toggle-group>
        </div>
      }
    </div>
  }
</div>
